import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotifications } from 'app/application/application'
import { useApi } from 'app/common/application'

import {
  DaySpent,
  SpentsGetRequest,
  SpentsGetResponse,
  TreatmentSpent,
  mapDaySpents,
  mapTreatmentSpents,
} from '../types'

const useSpents = (audienceId: string) => {
  const { create } = useApi()
  const { createNotification } = useNotifications()
  const { t } = useTranslation('error')

  const [daySpents, setDaySpents] = useState<DaySpent[]>(mapDaySpents([]))
  const [totalSpent, setTotalSpent] = useState(0)
  const [treatmentSpents, setTreatmentSpents] = useState<TreatmentSpent[]>(mapTreatmentSpents([]))

  const fetchData = useCallback(() => {
    if (audienceId) {
      void create<SpentsGetRequest, SpentsGetResponse>('/analytics/signals/treatmentSpend/query', {
        content: { signalId: audienceId },
      }).then((result) => {
        if (result.ok) {
          const data = result.val.data

          setTotalSpent(data.totalSpend)
          setTreatmentSpents(mapTreatmentSpents(data.treatments))
          setDaySpents(mapDaySpents(data.treatments))
        } else {
          createNotification({
            message: result.val.message,
            title: t(`http.${result.val.code}`),
            type: 'error',
          })

          setTotalSpent(0)
          setTreatmentSpents([])
        }
      })
    }
  }, [audienceId, create, createNotification, t])

  useEffect(fetchData, [fetchData])

  return {
    daySpents,
    totalSpent,
    treatmentSpents,
  }
}

export default useSpents
